import React, { FC } from "react";
import { ConditionalWrapper } from "../../../../helpers/conditional-wrapper";
import { Tooltip } from "antd";
import styles from "./question-components.module.scss";

interface QuestionTagProps {
  selected?: boolean;
  text: string;
  tooltip?: string;
  onClick: () => void;
}

export const QuestionTag: FC<QuestionTagProps> = ({
  selected,
  text,
  tooltip,
  onClick,
}) => {
  return (
    <ConditionalWrapper
      condition={!!tooltip}
      wrapper={(children) => <Tooltip title={tooltip}>{children}</Tooltip>}
    >
      <div
        className={selected ? styles.questionTagSelected : styles.questionTag}
        onClick={onClick}
      >
        {text}
      </div>
    </ConditionalWrapper>
  );
};
